<div *ngIf="showListLearner">
  <!--selection de l'apprenant-->
  <div class="container">
    <div class="row col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6 mt-3" *ngIf="learnerList.length > 0">
      <div class="mt-2 mr-2">
        {{'Learnerschoice'|trad}} :
      </div>

      <select class="col-7 mr-1 mr-md-4 form-control" (change)="selectLearner($event.target.value)">
        <option value="">{{'Selectalearner'|trad}}</option>
        <option *ngFor="let appr of learnerList" [value]="appr.Ident" [selected]="appr.Ident == identApprenant">
          {{appr.Prenom}} {{appr.Nom}}
        </option>
      </select>
      <!--<button class="q-btn q-main">Exporter <i class="fas fa-chart-bar ml-2"></i></button>-->
    </div>
    <div class="row col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6" *ngIf="learnerList.length == 0">
      {{'Nolearnerstoselect'|trad}}
    </div>
  </div>
  <!--fin selection de l'apprenant-->
</div>

<div *ngIf="loaded && showData">
  <div class="container-fluid">

    <!--entete avec titre-->
    <div class="container mb-4">
      <div class="row">
        <div class="w-100 page_title">
          <h1 class="q-police">
            <strong class="q-police-title">
              <i class="fas fa-chart-bar mr-2"></i>{{'cycleStats' | trad}}
            </strong>
          </h1>
        </div>
      </div>
    </div>
    <!--fin entete avec titre-->

    <hr />

    <!--selection de l'apprenant-->
    <div class="container">
      <div class="row col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6">
        <select id="cycle" class="col-7 mr-1 mr-md-4 form-control" (change)="selectCycle($event.target.value)">
          <option *ngFor="let cycle of DetailApprenantEL.CycleInfo" [value]="cycle.identCyc" [selected]="cycle.identCyc == identCycle">
            {{cycle.NomCyc}}
          </option>
        </select>
      </div>
    </div>
    <!--fin selection de l'apprenant-->
    <!--bandeau principal-->
    <div class="container-fluid">
      <div class="row">

        <div class="row col-lg-4 apprenant-infos-container">
          <!--photo de l'apprenant-->
          <div class="circle circle-size overflow-hidden mr-3"
               [ngClass]="{'q-light-grey':DetailApprenantEL.PathImgApprenant === '' || DetailApprenantEL.PathImgApprenant === null}">
            <img *ngIf="DetailApprenantEL.PathImgApprenant && DetailApprenantEL.PathImgApprenant!==''"
                 [src]="getUrl(this.DetailApprenantEL.PathImgApprenant)" alt="" />
            <q-avatar *ngIf="DetailApprenantEL.PathImgApprenant === '' || DetailApprenantEL.PathImgApprenant === null"
                      class="align-self-center"
                      [name]="DetailApprenantEL.InfoApprenant[0]['Pre01PER'] + ' ' + DetailApprenantEL.InfoApprenant[0]['NomfaPER']"
                      [size]="'170'"></q-avatar>
          </div>
          <!--fin photo de l'apprenant-->
          <!--infos de l'apprenant-->
          <div class="ml-3 q-text-style">
            <h4 class="font-weight-bold">{{DetailApprenantEL.InfoApprenant[0]['NomfaPER']}}</h4>
            <h4 class="font-weight-bold">{{DetailApprenantEL.InfoApprenant[0]['Pre01PER']}}</h4>
            <h6 class="font-weight-bold q-c-main">{{DetailApprenantEL.InfoApprenant[0]['SociePER']}}</h6>
            <h6 class="p-0 m-0">
              <i *ngIf="DetailApprenantEL.InfoApprenant[0]['NeproPER'] && DetailApprenantEL.InfoApprenant[0]['NeproPER'] !== ''"
                 class="q-c-main far fa-envelope mr-2"></i>
              {{DetailApprenantEL.InfoApprenant[0]['NeproPER']}}
            </h6>
            <p class="p-0 m-0">
              <i *ngIf="DetailApprenantEL.InfoApprenant[0]['NtproPER'] && DetailApprenantEL.InfoApprenant[0]['NtproPER'] !== ''"
                 class="q-c-main fas fa-phone mr-2 fa-flip-horizontal"></i>
              {{DetailApprenantEL.InfoApprenant[0]['NtproPER']}}
            </p>
          </div>
          <!--fin infos de l'apprenant-->
        </div>

        <!--bandeau avec les cercles-->
        <div class="row headband col-lg-8 circles-band-container my-2">

          <div class="w-100 background-circles q-prisme"></div>

          <div class="row w-100 h-100 p-0 m-0 justify-content-center position-absolute">
            <div class="row col-xl-11">


              <div *ngFor="let infoCircle of arrayCircle" class="d-flex col-sm-3 justify-content-center">
                <div class="position-relative flip-card" data-toggle="modal" [attr.data-target]="infoCircle.modal" [style.cursor]="infoCircle.flip ? 'pointer': 'auto'">
                  <div class="circle circle-size" [ngClass]="{'flip-card-inner' : infoCircle.flip}">
                    <button class="w-100 h-100 q-bg-none flip-card-front">

                      <i class="q-icon-button w-100 {{infoCircle.fontAwsome}} q-c-main"></i>
                      <h6 class="w-100 p-0 m-0">{{infoCircle.title |trad}}</h6>

                      <h4 *ngIf="infoCircle.title === 'timeSpent'; else noFormatSecond" class="w-100">{{infoCircle.value | formatSecond}} </h4>
                      <ng-template #noFormatSecond>
                        <h4 class="w-100">{{infoCircle.value}}</h4>
                      </ng-template>
                    </button>
                    <button *ngIf="infoCircle.flip" class="w-100 h-100 justify-content-center q-c-white q-main q-bg-none q-show-hover-secondary flip-card-back">
                      <i class="far fa-eye fa-3x"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--fin bandeau principal-->

    <hr />
    <div *ngIf="DetailCycleEL.ListChapitre && DetailCycleEL.ListChapitre.length > 0" class="my-4" #cycleContainer>
      <div *ngFor="let chapitre of DetailCycleEL.ListChapitre">
        <div class="q-bloc-chapter">
          <div class="row pr-0 q-pointer m-0 q-text-l" (click)="expendList($event, chapitre)">
            <div class="col-2 align-items-center" [ngClass]="IsMobile ? 'd-none' : 'd-flex'">
              <img [src]="returnImgChapter(chapitre.Image)" *ngIf="chapitre.Image && chapitre.Image.length > 0" class="img-chap">
              <img [src]="returnImgChapter('assets/images/Chapitres_placeholder.png')" *ngIf="!chapitre.Image || chapitre.Image.length == 0" class="img-chap">
            </div>
            <div class="d-flex col-3 align-items-center">
              <strong class="q-c-main">{{chapitre.Titre}}</strong>
            </div>
            <div class="d-flex align-items-center" [ngClass]="IsMobile ? 'col-2' : 'col-1'">
              ({{chapitre.NbModuleFait}}/{{chapitre.NbModuleTotal}})
            </div>
            <div class="d-flex col-1 align-items-center">
              <div [ngClass]="getEtat(chapitre.Etat)"></div>
            </div>
            <div class="d-flex align-items-center" [ngClass]="IsMobile ? 'col-2' : 'col-1'">
              <div class="fas fa-percent icon-chap q-c-main mr-1">
              </div>
              <span>
                {{chapitre.Avancement}}
              </span>
            </div>
            <div class="d-flex align-items-center" [ngClass]="IsMobile ? 'col-2' : 'col-1'">
              <div class="far fa-clock icon-chap q-c-main mr-1">
              </div>
              <span>
                {{getTimeSpend(chapitre.TempsPasse)}}
              </span>
            </div>
            <div class="d-flex align-items-center" [ngClass]="IsMobile ? 'col-1' : 'col-2'">
              <div class="fas fa-shoe-prints icon-chap q-c-main mr-1">
              </div>
              <span *ngIf="!IsMobile">
                {{getTextPassage(chapitre.NbPassage)}}
              </span>
              <span *ngIf="IsMobile">
                {{chapitre.NbPassage}}
              </span>
            </div>
            <i class="fas fa-chevron-down chevron ml-auto mt-2"></i>
          </div>

          <q-BarDetailNote *ngIf="chapitre.Ident && chapitre.Ident !== '' && chapitre.IsOpen" [IdChapitre]="chapitre.Ident" [IdCycle]="identCycle" [IdApprenant]="identApprenant"></q-BarDetailNote>

          <div class="list-closed d-none" #chapELContainer>



            <table class="text-center w-100 table-striped">
              <thead>
                <tr>
                  <th>{{'Moduletitle'|trad}}</th>
                  <th>{{'Status'|trad}}</th>
                  <th>{{'timeSpent'|trad}}</th>
                  <th>{{'Validationtest_EL'|trad}}</th>
                  <th>{{'Numberofpassages'|trad}}</th>
                </tr>
              </thead>
              <tbody>

                <ng-container *ngFor="let module of chapitre.ListModule">

                  <tr>
                    <td class="px-2 q-td-name">
                      {{module.Titre}}
                    </td>
                    <td class="px-2">
                      <div [ngClass]="getEtat(module.Etat)"></div>
                    </td>
                    <td class="px-2 q-td-url">
                      <div class="far fa-clock icon-chap q-c-main mr-1">
                      </div>
                      <span>
                        {{getTimeSpend(module.TempsPasse)}}
                      </span>
                    </td>
                    <td class="px-2 q-td-url">
                      <div *ngIf="module.StrNoteObtenue == 'NOTEST'">
                        <span>
                          Pas de test de validation
                        </span>
                      </div>
                      <div *ngIf="module.StrNoteObtenue != 'NOTEST'">
                        <div class="fas fa-award icon-chap q-c-main mr-1" *ngIf="module.HasCertificationTest" title="{{'Certificationquestionnaire'|trad}}">
                        </div>
                        <div class="fas fa-question-circle icon-chap q-c-main mr-1" *ngIf="!module.HasCertificationTest" title="{{'Validationtest_EL'|trad}}">
                        </div>
                        <span [ngClass]="module.TestSuccess ? 'q-main' : 'q-danger'" class="px-2 mx-2" *ngIf="!module.HasCertificationInProgress">
                          {{module.StrNoteObtenue}}
                        </span>
                        <div class="fas fa-download icon-chap q-c-main mr-1" title="{{'Downloadthequestionnaire_EL'|trad}}" (click)="downloadQuest(module.Ident)" *ngIf="!module.HasCertificationInProgress">
                        </div>
                        <div class="fas fa-play-circle icon-big q-c-primary" title="Certification en cours" *ngIf="module.HasCertificationInProgress"></div>
                      </div>

                    </td>
                    <td class="px-2">
                      <div class="fas fa-shoe-prints icon-chap q-c-main mr-1">
                      </div>
                      <span>
                        {{getTextPassage(module.NbPassage)}}
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--<extranet-BarAvancement *ngIf="DetailCycleEL.ListChapitre && DetailCycleEL.ListChapitre.length > 0 && identChapitre && identChapitre !== '' && identCycle && identCycle !== ''"
                            [IdChapitre]="identChapitre" [IdCycle]="identCycle">
    </extranet-BarAvancement>-->
  </div>

  <div class="modal fade" id="modalModuleCompleted" tabindex="-1" role="dialog" aria-labelledby="modalModuleCompleted" aria-hidden="true" #modalModuleCompleted>
    <div class="modal-dialog modal-dialog-centered q-modal-size" role="document">
      <div class="modal-content modal-content-grid">
        <div class="modal-header">
          <h5 class="q-c-main font-weight-bold modal-title ml-3">
            <i class="fas fa-users"></i>
            {{'modulesCompleted' |trad}}
          </h5>
          <button type="button" class="close mr-1" data-dismiss="modal" aria-label="Close" #closeModuleCompleted>
            <span aria-hidden="true"><i class="fas fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body modal-body-grid">
          <div *ngIf="identCycle" class="h-100 w-100">
            <q-listeModules class="h-100 w-100" [identCycle]="identCycle" [identApprenant]="identApprenant"></q-listeModules>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div *ngIf="!showData && loaded">
  <div class="container-fluid">
    <!--entete avec titre-->
    <div class="container mb-4">
      <div class="row">
        <div class="w-100 page_title">
          <h1 class="q-police">
            <strong class="q-police-title">
              <i class="fas fa-chart-bar mr-2"></i>{{'cycleStats' | trad}}
            </strong>
          </h1>
        </div>
      </div>
    </div>
    <!--fin entete avec titre-->

    <hr />

    <!--bandeau principal-->
    <div class="container-fluid">
      <div class="row">

        <div class="row col-lg-4 apprenant-infos-container">
          <!--photo de l'apprenant-->
          <div class="circle circle-size overflow-hidden mr-3"
               [ngClass]="{'q-light-grey':dataUser.PhotoPER === '' || dataUser.PhotoPER === null}">
            <img *ngIf="dataUser.PhotoPER && dataUser.PhotoPER!==''"
                 [src]="dataUser.PhotoPER" alt="" />
            <q-avatar *ngIf="dataUser.PhotoPER === ''"
                      class="align-self-center"
                      [name]="dataUser.Pre01PER + ' ' + dataUser.NomfaPER"
                      [size]="'170'"></q-avatar>
          </div>
          <!--fin photo de l'apprenant-->
          <!--infos de l'apprenant-->
          <div class="ml-3 q-text-style">
            <h4 class="font-weight-bold">{{dataUser.NomfaPER}}</h4>
            <h4 class="font-weight-bold">{{dataUser.Pre01PER}}</h4>
            <h6 class="p-0 m-0">
              <i *ngIf="dataUser.NeproPER && dataUser.NeproPER !== ''"
                 class="q-c-main far fa-envelope mr-2"></i>
              {{dataUser.NeproPER}}
            </h6>
          </div>
          <!--fin infos de l'apprenant-->
        </div>

        <!--bandeau avec les cercles-->
        <div class="row headband col-lg-8 circles-band-container my-2">

          <div class="w-100 background-circles q-prisme"></div>

          <div class="row w-100 h-100 p-0 m-0 justify-content-center position-absolute">
            <div class="row col-xl-11">


              <div *ngFor="let infoCircle of arrayCircle" class="d-flex col-sm-3 justify-content-center">
                <div class="position-relative flip-card" data-toggle="modal" [attr.data-target]="infoCircle.modal" [style.cursor]="infoCircle.flip ? 'pointer': 'auto'">
                  <div class="circle circle-size" [ngClass]="{'flip-card-inner' : infoCircle.flip}">
                    <button class="w-100 h-100 q-bg-none flip-card-front">

                      <i class="q-icon-button w-100 {{infoCircle.fontAwsome}} q-c-main"></i>
                      <h6 class="w-100 p-0 m-0">{{infoCircle.title |trad}}</h6>

                      <h4 *ngIf="infoCircle.title === 'timeSpent'; else noFormatSecond" class="w-100">{{infoCircle.value | formatSecond}} </h4>
                      <ng-template #noFormatSecond>
                        <h4 class="w-100">{{infoCircle.value}}</h4>
                      </ng-template>
                    </button>
                    <button *ngIf="infoCircle.flip" class="w-100 h-100 justify-content-center q-c-white q-main q-bg-none q-show-hover-secondary flip-card-back">
                      <i class="far fa-eye fa-3x"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--fin bandeau principal-->

    <hr />
    <div class="row justify-content-center pt-5 m-0">
      <div class="col-10 col-sm-10 col-md-6 col-lg-6">
        <div class="card q-nocycle-card text-center">
          <div class="card-block color_card row">
            <div class="col-0 col-sm-0 col-md-1 col-lg-1"></div>
            <div class="card-body col-12 col-sm-12 col-md-10 col-lg-10 q-police">
              <h2 class="text-center">
                <strong>
                  {{'Noaffectedcycle_EL'|trad}}
                </strong>
              </h2>
              <h1 class="text-center"><i class="fas fa-table"></i></h1>
              <h3 class="text-center">
                {{'nocycletext1_EL'|trad}}. {{'nocycletext2_EL'|trad}}.
              </h3>
            </div>
            <div class="col-0 col-sm-0 col-md-1 col-lg-1"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
